<template>
  <div class="page_view">
    <div class="page_title backdrop">About Cedric Hobbs</div>
    <div class="page_content backdrop">
      <p>I live in San Jose, California, where I work as a software engineer,
         specializing in web applications and user interfaces.</p>
      <p>In my free time, I enjoy home improvement & landscaping projects,
         music (including composition), sewing, video games, baking, and travel.
         See my <a href="http://cedrichobbs.wordpress.com">WordPress blog</a>
         for some fun travel stories!</p>
    </div>
  </div>
</template>

<script>

export default {
    name : "About"
};

</script>

<style scoped>

</style>
